import { Box, Typography, Grid, CircularProgress, Divider, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Card } from '@mui/material';
import { Formik, Form, FieldArray } from 'formik';
import axios from 'axios';
import React, { useState, useEffect } from "react";
import { GET_INVOICE_EXPORT_PROFORMA_INVOICE, READ_BL_DRAFT_EXPORT } from '../../../services/apiRoutes';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import DetailsParticulars from '../../common/DetailsPage/DetailsParticulars';
import CustomPrintModel from '../../common/CustomPrint';
import { printFunction } from '../../../services/apiServices';
import { genericPost } from '../../../services/authServices';
import { BLDraftPrintFirst } from '../PrintPdf/BLDraftPrint';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import { t } from '../../../constants/translationHelper';

const BLDraftView = ({ handleClose, setMessage, fetchData, blDraftId, templateId, shipmentOrgId }) => {
    const companyDateFormat = useCompanyDateFormat();

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const [termConditions, setTermConditions] = useState([]);
    const [companyBanks, setCompanyBanks] = useState([]);
    const [shipments, setShipments] = useState([]);
    const [shippingBooking, setShippingBooking] = useState([]);
    const [paymentVoucher, setPaymentVoucher] = useState([]);
    const [companyTaxes, setCompanyTaxes] = useState([]);
    const [shippingmark, setShippingmark] = useState([]);

    useEffect(() => {
        fetchDataInvoice();
    }, []);

    const fetchDataInvoice = async () => {
        setLoading(true);
        try {
            const payload = { shipmentOrgId: shipmentOrgId };
            const response = await genericPost(GET_INVOICE_EXPORT_PROFORMA_INVOICE, payload);
            if (response?.data?.success) {
                const resData = response.data.data;
                setTermConditions(resData.termConditions || []);
                setCompanyBanks(resData.companyBanks || []);
                setShipments(resData.shipments || []);
                setShippingBooking(resData.shippingBooking || []);
                setPaymentVoucher(resData.paymentVoucher || []);
                setCompanyTaxes(resData.companyTaxes || []);
                setShippingmark(resData.shippingmark || []);
            } else {
                setError('No data found');
            }
        } catch (err) {
            console.error('Error fetching data:', err);
            setError('Error fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!blDraftId) return;

        const fetchData = async () => {
            try {
                const accessToken = sessionStorage.getItem('accessToken');
                const response = await axios.get(READ_BL_DRAFT_EXPORT(blDraftId), {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                setData(response.data.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [blDraftId]);

    if (loading) return <CircularProgress />;
    if (error) return <p>Error: {error}</p>;

    const formatPort = (port, country) => [port, country].filter(Boolean).join(", ");


    const values = {
        blDraftId: data?.blDraftId || '',
        userId: data?.userId || '',
        companyId: data?.companyId || '',
        clientCompanyId: data?.clientCompanyId || '',
        shipper: data?.shipper || '',
        paymentMethod: data?.paymentMethod || '',
        blNumber: data?.blNumber || '',
        orderMethod: data?.orderMethod || '',
        consignee: data?.consignee || '',
        hsCode: data?.hsCode || '',
        specialRequirement: data?.specialRequirement || '',
        notifyParty: data?.notifyParty || '',
        alsoNotify: data?.alsoNotify || '',
        oceanVesselVoyNo: data?.oceanVesselVoyNo || '',
        portOfLoading: formatPort(
            data?.loading?.portName,
            data?.loading?.country?.name
        ),
        portOfDestination: formatPort(
            data?.destination?.portName,
            data?.destination?.country?.name
        ),
        excessValueDeclaration: data?.excessValueDeclaration || '',
        finalDestination: data?.finalDestination || '',
        freightPayableAt: data?.freightPayableAt || '',
        noOfOriginals: data?.noOfOriginals || '',
        marks: data?.marks || '',
        noOfPkgs: data?.noOfPkgs || '',
        descriptionOfGoods: data?.descriptionOfGoods || '',
        grossWeightData: data?.grossWeight || '',
        grossWeight: data?.grossWeight || '',
        measurementData: data?.measurement || '',
        measurement: data?.measurement || '',
        createdAt: data?.createdAt || '',
        updatedAt: data?.updatedAt || '',
        OnBoardDate: companyDateFormat(data?.OnBoardDate) || '',
        particulars: data?.particulars || [],
    };


    const labels = [
        { key: 'shipper', label: 'Shipper', sm: 12, md: 6 },
        { key: 'paymentMethod', label: 'Payment Method', sm: 12, md: 6 },
        { key: 'consignee', label: 'Consignee', sm: 12, md: 6 },
        { key: 'blNumber', label: 'BL Number', sm: 12, md: 6 },
        { key: 'orderMethod', label: 'Order Method', sm: 12, md: 6 },
        { key: 'hsCode', label: 'HS Code', sm: 12, md: 6 },
        { key: 'specialRequirement', label: 'Special Requirement', sm: 12, md: 6 },
        { key: 'notifyParty', label: 'Notify Party', sm: 12, md: 6 },
        { key: 'alsoNotify', label: 'Also Notify', sm: 12, md: 6 },
        { key: 'oceanVesselVoyNo', label: 'Ocean Vessel Voy No', sm: 12, md: 6 },
        { key: 'portOfLoading', label: 'Port of Loading', sm: 12, md: 6 },
        { key: 'excessValueDeclaration', label: 'Excess Value Declaration', sm: 12, md: 6 },
        { key: 'portOfDestination', label: 'Port of Destination', sm: 12, md: 6 },
        { key: 'finalDestination', label: 'Final Destination', sm: 12, md: 6 },
        { key: 'freightPayableAt', label: 'Freight Payable At', sm: 12, md: 6 },
        { key: 'noOfOriginals', label: 'No. of Originals', sm: 12, md: 6 },

    ];

    const column = [
        { id: 'marks', label: 'marks', accessor: 'marks' },
        { id: 'noOfPkgs', label: 'No. of Packages', accessor: 'noOfPkgs' },
        { id: 'descriptionOfGoods', label: 'Description of Goods', accessor: 'descriptionOfGoods' },
        { id: 'grossWeightData', label: 'Gross Weight', accessor: 'grossWeightData' },
        { id: 'measurementData', label: 'Measurement', accessor: 'measurementData' },
    ];

    const particularsColumns = [
        { id: 'sealNo', label: 'Seal No', accessor: 'sealNo' },
        { id: 'type', label: 'Type', accessor: 'type' },
        { id: 'noOfPkgs', label: 'No of Packages', accessor: 'noOfPkgs' },
        { id: 'grossWeight', label: 'Gross Weight', accessor: 'grossWeight' },
        { id: 'measurement', label: 'Measurement', accessor: 'measurement' },
    ];


    const clientCompanyName = data?.customer?.clientCompanyName || '';
    const encodedCompanyName = clientCompanyName.replace(/ /g, '').toLowerCase();
    const fileName = `bl_draft_${encodedCompanyName}.pdf`;

    const printContent = () => {
        const elementId = 'contentId';
        const iframeId = 'print-iframe';
        printFunction(elementId, iframeId, fileName);
    };
    const pdfContent = () => {
        const elementId = 'contentpdf';
        const iframeId = 'print-iframe';
        printFunction(elementId, iframeId, fileName);
    };

    // const check = parseInt(templateId);
    const footerFalse = false;
    const footerTrue = true;

    const check = parseInt(templateId);

    const getPrintContent = () => {
        if (check === 1) {
            return (<BLDraftPrintFirst
                invoiceData={data}
                termConditions={termConditions}
                companyBanks={companyBanks}
                shippingBooking={shippingBooking}
                shipments={shipments}
                paymentVoucher={paymentVoucher}
                companyTaxes={companyTaxes}
                shippingmark={shippingmark}
                footer={footerFalse} />);
        }
        if (check === 2) {
            return (
                <BLDraftPrintFirst

                    invoiceData={data}
                    termConditions={termConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    footer={footerFalse} />);
        }
        if (check === 3) {
            return (
                <BLDraftPrintFirst

                    invoiceData={data}
                    termConditions={termConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    footer={footerFalse} />);
        }
        if (check === 4) {
            return (
                <BLDraftPrintFirst

                    invoiceData={data}
                    termConditions={termConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    footer={footerFalse} />);
        }

        return <BLDraftPrintFirst

            invoiceData={data}
            termConditions={termConditions}
            companyBanks={companyBanks}
            shippingBooking={shippingBooking}
            shipments={shipments}
            paymentVoucher={paymentVoucher}
            companyTaxes={companyTaxes}
            shippingmark={shippingmark}
            footer={footerFalse} />;
    };

    const getPdfContent = () => {
        if (check === 1) {
            return (<BLDraftPrintFirst

                invoiceData={data}
                termConditions={termConditions}
                companyBanks={companyBanks}
                shippingBooking={shippingBooking}
                shipments={shipments}
                paymentVoucher={paymentVoucher}
                companyTaxes={companyTaxes}
                shippingmark={shippingmark}
                footer={footerTrue} />);
        }
        if (check === 2) {
            return (
                <BLDraftPrintFirst

                    invoiceData={data}
                    termConditions={termConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    footer={footerTrue} />);
        }
        if (check === 3) {
            return (
                <BLDraftPrintFirst

                    invoiceData={data}
                    termConditions={termConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    footer={footerTrue} />);
        }
        if (check === 4) {
            return (
                <BLDraftPrintFirst

                    invoiceData={data}
                    termConditions={termConditions}
                    companyBanks={companyBanks}
                    shippingBooking={shippingBooking}
                    shipments={shipments}
                    paymentVoucher={paymentVoucher}
                    companyTaxes={companyTaxes}
                    shippingmark={shippingmark}
                    footer={footerTrue} />);
        }

        return <BLDraftPrintFirst

            invoiceData={data}
            termConditions={termConditions}
            companyBanks={companyBanks}
            shippingBooking={shippingBooking}
            shipments={shipments}
            paymentVoucher={paymentVoucher}
            companyTaxes={companyTaxes}
            shippingmark={shippingmark}
            footer={footerTrue}
        />;
    };

    return (
        <>

            <CustomPrintModel contentId="contentId">
                {getPrintContent()}
            </CustomPrintModel >

            <CustomPrintModel contentId="contentpdf">
                {getPdfContent()}
            </CustomPrintModel >

            <Box sx={{ mx: 'auto', mt: 0 }}>
                <Formik initialValues={values} enableReinitialize>
                    {() => (
                        <Form>
                            <Grid container spacing={1}>
                                <Grid item xs={4}>
                                    <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#212529" }}>
                                        {t("BL Draft")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Box>
                                        <IconButton aria-label="delete">
                                            <DeleteOutlineOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                        <IconButton aria-label="print" onClick={printContent}>
                                            <LocalPrintshopOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                        <IconButton aria-label="print" onClick={pdfContent}>
                                            <PictureAsPdfOutlinedIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                        <IconButton aria-label="close" onClick={handleClose} >
                                            <CloseIcon sx={{ fontSize: '20px', color: '#007bff' }} />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Divider />
                            <Grid container spacing={1} style={{ marginTop: "5px" }}>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Card variant='outlined' sx={{ height: "100px" }}>
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Shipper")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px", }}>
                                            {values.shipper}
                                        </Typography>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Card variant='outlined'>
                                        <Box sx={containerStyle}>
                                            <Box sx={innerBoxStyle}>
                                                <Typography variant="body1" sx={labelTextStyle}>
                                                    {t("Payment Method")}
                                                </Typography>
                                                <Typography variant="body1"> {values.paymentMethod}</Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={containerStyle} style={{ paddingTop: "12px", paddingBottom: "12px" }}>
                                            <Box sx={innerBoxStyle}>
                                                <Typography variant="body1" sx={labelTextStyle}>
                                                    {t("BL Number")}
                                                </Typography>
                                                <Typography variant="body1"> {values.blNumber}</Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={containerStyle}>
                                            <Box sx={innerBoxStyle}>
                                                <Typography variant="body1" sx={labelTextStyle}>
                                                    {t("Order Method")}
                                                </Typography>
                                                <Typography variant="body1"> {values.orderMethod}</Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Grid>


                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Card variant='outlined' sx={{ height: "118px" }}>
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Consignee")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px", }}>
                                            {values.consignee}
                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("HS Code")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.hsCode}

                                        </Typography>

                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Please Indicate any special requirement below")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.specialRequirement}

                                        </Typography>
                                    </Card>
                                </Grid>


                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Notify Party")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.notifyParty}

                                        </Typography>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Also Notify")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.alsoNotify}
                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Ocean Vessel Voy No.")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.oceanVesselVoyNo}
                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Port of Loading")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.portOfLoading}

                                        </Typography>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={4} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Excess Value Declaration")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.excessValueDeclaration}

                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("On Board Date")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.OnBoardDate}

                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Port Of Destination")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.portOfDestination}

                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Final Destination")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.finalDestination}

                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("Freight Payable at")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.freightPayableAt}

                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <Card variant='outlined' >
                                        <Box display="flex" flexDirection="row" paddingLeft={1} style={{ height: '30px', backgroundColor: "#e7f0f7" }}>
                                            <Box >
                                                <Typography style={{ fontWeight: 500, color: "#212529", fontSize: "16px" }}>
                                                    {t("No.of originals")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider />
                                        <Typography style={{ padding: "2px" }}>
                                            {values.noOfOriginals}

                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer>
                                        <Table
                                            style={{
                                                width: "100%",
                                                border: "1px solid #dee2e6",
                                                borderCollapse: "collapse",
                                            }}
                                        >
                                            <TableHead style={{ height: '40px', backgroundColor: "#e7f0f7" }}>
                                                <TableRow style={{ border: "1px solid #dee2e6" }}>
                                                    <TableCell style={cellLabel}>{t("Marks")}</TableCell>
                                                    <TableCell style={cellLabel}>{t("No. of Packages")}</TableCell>
                                                    <TableCell style={cellLabel}>{t("Description of Goods")}</TableCell>
                                                    <TableCell style={cellLabel}>{t("Gross Weight")}</TableCell>
                                                    <TableCell style={cellLabel}>{t("Measurement")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow
                                                    style={{
                                                        border: "1px solid #dee2e6",
                                                        color: "#212529",
                                                        fontWeight: "600",
                                                        fontSize: "14px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "clip",
                                                    }}
                                                >
                                                    <TableCell style={tableCell}>{values.marks}</TableCell>
                                                    <TableCell style={tableCell}>{values.noOfPkgs}</TableCell>
                                                    <TableCell style={tableCell}>{values.descriptionOfGoods}</TableCell>
                                                    <TableCell style={tableCell}>{values.grossWeightData}</TableCell>
                                                    <TableCell style={tableCell}>{values.measurementData}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Box display="flex" flexDirection="row" alignItems="center">
                                        <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                            {t("Particulars")}
                                        </Typography>
                                    </Box>
                                    <DetailsParticulars
                                        title="Particulars"
                                        columns={particularsColumns}
                                        data={data?.particulars}
                                    />
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box >
        </>


    );
};

export default BLDraftView;


const cellLabel = {
    border: "1px solid #dee2e6",
    color: "#212529",
    fontWeight: "600",
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "clip",
    padding: "5px",
    textAlign: 'center',

}

const tableCell = {
    border: "1px solid #dee2e6",
    padding: "5px",
    textAlign: "left"

};
const containerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 4
};

const innerBoxStyle = {
    display: 'flex',
    alignItems: 'center',
};

const labelTextStyle = {
    fontWeight: '500',
    display: 'block',
    marginRight: '8px',
    backgroundColor: "#e7f0f7",
    pl: "10px",
    width: "170px",
};
